/**
 * AiSearchIcon — A magnifier with a spark: the search that reads the operator's words. Hugeicons
 * ai-search-02 (MIT).
 */

import svg from './svg/ai-search.svg?raw';
import { makeSvgIcon } from './svgIcon';

export const AiSearchIcon = makeSvgIcon('ai-search', svg);
